var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21381_70479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0.402344C6.99187 0.402344 0.5 6.89421 0.5 14.9023C0.5 22.9105 6.99187 29.4023 15 29.4023C23.0081 29.4023 29.5 22.9105 29.5 14.9023C29.5 6.89421 23.0081 0.402344 15 0.402344ZM15 27.5898C7.99288 27.5898 2.3125 21.9095 2.3125 14.9023C2.3125 7.89522 7.99288 2.21484 15 2.21484C22.0071 2.21484 27.6875 7.89522 27.6875 14.9023C27.6875 21.9095 22.0071 27.5898 15 27.5898Z",
    fill: "#ACB5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4688 12.1836C11.4698 12.1836 12.2812 11.3721 12.2812 10.3711C12.2812 9.37008 11.4698 8.55859 10.4688 8.55859C9.46773 8.55859 8.65625 9.37008 8.65625 10.3711C8.65625 11.3721 9.46773 12.1836 10.4688 12.1836Z",
    fill: "#ACB5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5312 12.1836C20.5323 12.1836 21.3438 11.3721 21.3438 10.3711C21.3438 9.37008 20.5323 8.55859 19.5312 8.55859C18.5302 8.55859 17.7188 9.37008 17.7188 10.3711C17.7188 11.3721 18.5302 12.1836 19.5312 12.1836Z",
    fill: "#ACB5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3438 14.9023C21.3438 18.4059 18.5036 21.2461 15 21.2461C11.4964 21.2461 8.65625 18.4059 8.65625 14.9023H6.84375C6.84375 19.4069 10.4954 23.0586 15 23.0586C19.5046 23.0586 23.1562 19.4069 23.1562 14.9023H21.3438Z",
    fill: "#ACB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21381_70479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "translate(0.5 0.402344)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileIcon);
export default __webpack_public_path__ + "static/media/SmileIcon.79bdacbb962f45519595a26b596a790b.svg";
export { ForwardRef as ReactComponent };